import React from "react";
import { Switch, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import MyCompanies from "./pages/MyCompanies";
import Connections from "./pages/Connections";
import PushEntries from "./pages/PushEntries";
import PullLinks from "./pages/PullLinks";
import BookClosure from "./pages/BookClosure";
import ModulesLibrary from "./pages/ModulesLibrary";
import ImportPresets from "./pages/ImportPresets";
import FscpPostings from "./pages/FscpPostings";
import BookClosureTB from "./pages/BookClosureTB";
import FscpPostingView from "./pages/FscpPostingView";
import FscpPostingLogs from "./pages/FscpPostingLogs";
import BookClosureComments from "./pages/BookClosureComments";
import EditGeneralTemplate from "./pages/EditGeneralTemplate";
import FSCPMatrix from "./pages/FSCPMatrix";

import CompanyDetails from "./pages/CompanyDetails";
import ERPConnectors from "./pages/ERPConnectors";
import Definitions from "./components/companyedit/DefinitionsComponents/Definitions.jsx";
import ReceivablesDefinitions from "./components/companyedit/DefinitionsComponents/ReceivablesDefinitions.jsx";
import AccountingPolicy from "./components/companyedit/AccountingPolicy/AccountingPolicy.jsx";
import CreateLoansEclScenario from "./components/companyedit/AccountingPolicy/CreateLoansEclScenario.jsx";
import CreateReceviablesEclScenario from "./components/companyedit/AccountingPolicy/CreateReceviablesEclScenario.jsx";
import LoanPolicy from "./components/companyedit/AccountingPolicy/LoansPolicies.jsx";
import ReceivablesPolicy from "./components/companyedit/AccountingPolicy/ReceivablesPolicies.jsx";
import DataBase from "./components/companyedit/DataBase/DataBase.jsx";

import LoanOverView from "./components/loans/overView/OverView.jsx";
import LoansListing from "./components/loans/Listing/Listing.jsx";
import LoanRegisterStaging from "./components/loans/ComputeCalculations/loansStaging/Staging.jsx";
import LoanRegisterEir from "./components/loans/ComputeCalculations/EIR/Eir.jsx";
import LoanRegisterEcl from "./components/loans/ComputeCalculations/ECL/Ecl.jsx";
import LoanRegisterIrac from "./components/loans/ComputeCalculations/IRAC/Irac.jsx";

import ReceivablesListing from "./components/receivables/Listing/Listing.jsx";
import ReceivablesRegisterEcl from "./components/receivables/ComputeCalculations/ECL/Ecl.jsx";

import Overview from "./pages/payables/Overview";
import Listing from "./pages/payables/Listing";
import ComputeCalculation from "./pages/payables/ComputeCalculation";

import CoaListing from "./pages/coa/Listing";

import Dashboard from './components/investmentregister/Dashboard.jsx';
import ShareCapital from './components/investmentregister/ShareCapital.jsx';
import KeyManagerialPersons from './components/investmentregister/KeyManagerialPersons.jsx';
import Repository from './components/investmentregister/Repository.jsx';
import investmentTimeline from  "./components/investmentregister/InvestmentTimeline.jsx";
import DeletedRegisters from './components/registers/DeletedRegisters.jsx';

import StandaloneLibrary from './pages/libraries/StandaloneLibrary.jsx';
import ViewEditLibrary from './pages/libraries/ViewEditLibrary.jsx';
import PreviewSTTemplate from './pages/libraries/PreviewSTTemplate.jsx';

// import TextEditor from './components/RichTextEditor.jsx'
import TextEditor from './components/QuillReactEditor'
import StandaloneFinancialStatement from "./pages/standalone_fs/StandaloneFinancialStatement.js";


import SalesDashboard from "./pages/sales/Dashboard";
import SamplePage from "./pages/sales/SamplePage";
import SalesListing from "./pages/sales/Listing";

import PurchaseDashBoard from "./pages/purchase/PurchaseDashBoard";
import PurchaseListing from "./pages/purchase/PurchaseListing";

import FixedAssetListing from "./pages/fixedAsset/FixedAssetListing";
import FAMovementSummary from "./pages/fixedAsset/FAMovementSummary";
import ConsolPopulateFS from "./pages/consol/ConsolPopulateFS.js";
import ConsolPrePopulateFS from "./pages/consol/ConsolPrePopulateFS.js";
import CreateInvestment from "./components/investmentregister/CreateInvestment.jsx";
import IRDetails from "./components/investmentregister/IRDetails.jsx";

export default function AppV2() {
  return (
    <Layout>
      {" "}
      {/* Wrap Layout around Switch, not inside */}
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/myfinV2/my-companies" component={MyCompanies} />
        <Route exact path="/myfinV2/connections" component={Connections} />
        <Route
          exact
          path="/myfinV2/connections/push/view-entries"
          component={PushEntries}
        />
        <Route
          exact
          path="/myfinV2/connections/pull/view-links"
          component={PullLinks}
        />
        <Route exact path="/myfinV2/book-closure" component={BookClosure} />
        <Route
          exact
          path="/myfinV2/book-closure/modules-library"
          component={ModulesLibrary}
        />
        <Route
          exact
          path="/myfinV2/book-closure/import-presets"
          component={ImportPresets}
        />
        <Route
          exact
          path="/myfinV2/book-closure/fscp-posting"
          component={FscpPostings}
        />
        <Route
          exact
          path="/myfinV2/book-closure/fscp-posting-view"
          component={FscpPostingView}
        />
        <Route
          exact
          path="/myfinV2/book-closure/fscp-posting-logs"
          component={FscpPostingLogs}
        />
        <Route
          exact
          path="/myfinV2/book-closure/comments"
          component={BookClosureComments}
        />
        <Route
          exact
          path="/myfinV2/book-closure/tb"
          component={BookClosureTB}
        />
        <Route
          exact
          path="/myfinV2/book-closure/edit-general-template"
          component={EditGeneralTemplate}
        />
        <Route
          exact
          path="/myfinV2/book-closure/fscp-matrix"
          component={FSCPMatrix}
        />

        <Route
          exact
          path="/myfinV2/company-details/:companyId"
          component={CompanyDetails}
        />
        <Route
          exact
          path="/myfinV2/erp-connectors/:companyId"
          component={ERPConnectors}
        />

        <Route
          exact
          path="/myfinV2/accounting-policy/:companyId"
          component={AccountingPolicy}
        />
        <Route
          exact
          path="/myfinV2/loan-policy/:companyId"
          component={LoanPolicy}
        />

        <Route
          exact
          path="/myfinV2/loans/create-ecl-scenario/:companyId"
          component={CreateLoansEclScenario}
        />
        <Route
          exact
          path="/myfinV2/loans/update-ecl-scenario/:companyId/:eclId"
          component={CreateLoansEclScenario}
        />

        <Route
          exact
          path="/myfinV2/receivables-policy/:companyId"
          component={ReceivablesPolicy}
        />
        <Route
          exact
          path="/myfinV2/receivables/create-ecl-scenario/:companyId"
          component={CreateReceviablesEclScenario}
        />
        <Route
          exact
          path="/myfinV2/receivables/update-ecl-scenario/:companyId/:eclId"
          component={CreateReceviablesEclScenario}
        />
        <Route exact path="/myfinV2/database/:companyId" component={DataBase} />
        <Route
          exact
          path="/myfinV2/definitions/:companyId"
          component={Definitions}
        />
        <Route
          exact
          path="/myfinV2/receivables-definitions/:companyId"
          component={ReceivablesDefinitions}
        />

        <Route
          exact
          path="/myfinV2/loans/overview/:id/:companyId"
          component={LoanOverView}
        />
        <Route
          exact
          path="/myfinV2/loans/listing/:id/:companyId"
          component={LoansListing}
        />
        <Route
          exact
          path="/myfinV2/loans/staging/:id/:companyId"
          component={LoanRegisterStaging}
        />
        <Route
          exact
          path="/myfinV2/loans/eir/:id/:companyId"
          component={LoanRegisterEir}
        />
        <Route
          exact
          path="/myfinV2/loans/ecl/:id/:companyId"
          component={LoanRegisterEcl}
        />
        <Route
          exact
          path="/myfinV2/loans/irac/:id/:companyId"
          component={LoanRegisterIrac}
        />

        <Route
          exact
          path="/myfinV2/receivables/listing/:id/:companyId"
          component={ReceivablesListing}
        />
        <Route
          exact
          path="/myfinV2/receivables/ecl/:id/:companyId"
          component={ReceivablesRegisterEcl}
        />

        <Route path="/myfinV2/payables/overview/:id/:companyId" component={Overview} />
        <Route path="/myfinV2/payables/listing/:id/:companyId" component={Listing} />
        <Route path={["/myfinV2/coa/listing/:id/:companyId?", "/myfinV2/coa/listing/:id"]} component={CoaListing} />
        <Route
          path="/myfinV2/payables/computecalculation/:id/:companyId"
          component={ComputeCalculation}
        />
        <Route exact path="/myfinV2/receivables/listing/:id/:companyId" component={ReceivablesListing} />
        <Route exact path="/myfinV2/receivables/ecl/:id/:companyId" component={ReceivablesRegisterEcl} />

        <Route exact path="/myfinV2/library/standalone-library" component={StandaloneLibrary} />
        <Route exact path="/myfinV2/library/viewedit-library/:tempId" component={ViewEditLibrary} />
        <Route exact path="/myfinV2/text-editor" component={TextEditor} />
        <Route exact path="/myfinV2/preview-sttemplate/:tempId" component={PreviewSTTemplate} />
        <Route exact path="/myfinV2/IR/dashboard/:irId" component={Dashboard} />
        <Route exact path="/myfinV2/IR/sharecapital/:irId" component={ShareCapital} />
        <Route exact path="/myfinV2/IR/keymanagerialpersons/:irId" component={KeyManagerialPersons} />
        <Route exact path="/myfinV2/IR/repository/:irId" component={Repository} />
        <Route exact path="/myfinV2/standalonefs" component={StandaloneFinancialStatement} />
        <Route exact path="/myfinV2/console-prepopulatefs/:consolID" component={ConsolPrePopulateFS} />
        <Route exact path="/myfinV2/console-populatefs/:consolID" component={ConsolPopulateFS} />

        <Route path="/myfinV2/sales/dashboard" component={SalesDashboard} />
        <Route path="/myfinV2/sales/samplepage" component={SamplePage} />
        <Route path="/myfinV2/sales/listing/:id" component={SalesListing} />
        <Route path="/myfinV2/sales/listing" component={SalesListing} />

        <Route
          path="/myfinV2/purchase/dashboard"
          component={PurchaseDashBoard}
        />
        <Route path="/myfinV2/purchase/listing/:id" component={PurchaseListing} />
        <Route path="/myfinV2/purchase/listing" component={PurchaseListing} />

        <Route
          path="/myfinV2/fixedAsset/listing/:id"
          component={FixedAssetListing}
        />
        <Route
          path="/myfinV2/fixedAsset/listing"
          component={FixedAssetListing}
        />
        <Route
          path="/myfinV2/fixedAsset/summary"
          component={FAMovementSummary}
        />
        <Route
          exact
          path="/create-investment/:registerid"
          component={CreateInvestment}
        />
         <Route
          exact
          path="/detailsIR/:registerid"
          component={IRDetails}
        />
    
      <Route
       exact
       path="investment-timeline"
       component={investmentTimeline} />

      </Switch>
    </Layout>
  );
}
